// extracted by mini-css-extract-plugin
export default {"roles":"AssignmentNameWithRoles_roles__5GwGh","rounded":"AssignmentNameWithRoles_rounded__ewx+S"};